import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsOpen(!isOpen);

  // Close menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-brand">
          <Link to="/" className="brand-link">
            <img src="/logo.png" alt="Any Time Movers AU" className="logo" />
            <div className="brand-text">
              <span className="brand-name">Any Time Movers AU</span>
              <span className="brand-tagline">24/7 Moving Services</span>
            </div>
          </Link>
        </div>

        <div className={`nav-links ${isOpen ? 'open' : ''}`}>
          <Link to="/" onClick={toggleMenu}>Home</Link>
          <Link to="/services" onClick={toggleMenu}>Services</Link>
          <Link to="/quote" onClick={toggleMenu}>Get a Quote</Link>
          <Link to="/about" onClick={toggleMenu}>About Us</Link>
          <Link to="/gallery" onClick={toggleMenu}>Gallery</Link>
          <Link to="/contact" onClick={toggleMenu}>Contact Us</Link>
        </div>

        <div className={`hamburger ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </nav>
      
      {isOpen && <div className="menu-overlay" onClick={toggleMenu}></div>}
    </>
  );
};

export default Navbar;
